var _excluded = ["defaultIcon", "activeIcon", "onClick", "data-qa", "className", "classNames"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
import PropTypes from "prop-types";
import { joinCn } from "@ati/uti";
import styles from "./IconWithActive.module.scss";

/** Компонент активной/неактивной иконки */
var IconWithActive = _ref => {
  var {
      defaultIcon,
      activeIcon,
      onClick,
      "data-qa": dataQa = "icon-with-active",
      className,
      classNames = {}
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("span", _extends({
    className: joinCn(styles.icon, classNames.wrapper, className),
    "data-qa": dataQa
  }, rest), /*#__PURE__*/React.createElement("span", {
    className: joinCn(styles.default, classNames.default)
  }, defaultIcon), /*#__PURE__*/React.createElement("span", {
    role: "button",
    tabIndex: "0",
    className: joinCn(styles.active, classNames.active),
    onClick: onClick
  }, activeIcon));
};
IconWithActive.propTypes = {
  /** Дефолтный вид иконки */
  defaultIcon: PropTypes.node,
  /** Вид активной иконки */
  activeIcon: PropTypes.node,
  /** Дополнительный обработчик на клик */
  onClick: PropTypes.func,
  /** Дата атрибут для тестирования */
  "data-qa": PropTypes.string,
  /** Внешний класс */
  className: PropTypes.string,
  /** Объект, в котором можно прописать классы для любого из элементов */
  classNames: PropTypes.shape({
    /** Класс для дефолтного состояния */
    default: PropTypes.string,
    /** Класс для активного состояния */
    active: PropTypes.string,
    /** Класс для обертки */
    wrapper: PropTypes.string
  })
};
export default IconWithActive;